import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MoneyInputDirective } from '../../../../utils/directives/money-input.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PaymentMethodModel } from '../../../../domain/models/payment.model';

@Component({
  selector: 'app-payment-method-cash',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MoneyInputDirective
  ],
  templateUrl: './payment-method-cash.component.html',
  styleUrls: ['./payment-method-cash.component.css']
})
export class PaymentMethodCashComponent {
  @Input() method!: PaymentMethodModel;
  @Output() removed = new EventEmitter<string>();
  @Output() amountChanged = new EventEmitter<{ method: PaymentMethodModel; amount: number }>();

  onRemove(): void {
    this.removed.emit(this.method.id);
  }

  onAmountChange(value: string): void {
    // Prevent negative values for cash
    const parsed = Math.max(0, parseFloat(value) || 0);
    this.amountChanged.emit({ method: this.method, amount: parsed });
  }
}
